$(document).ready(function(){
  function animation_desktop(){
    $(".razorpay_btn_wrapper .carousel.desktop").toggleClass("transform");
    $(".razorpay_btn_wrapper .crumbs.desktop .crumb-item:nth-child(1)").toggleClass("dark");
    $(".razorpay_btn_wrapper .crumbs.desktop .crumb-item:nth-child(2)").toggleClass("light");
   }
    window.setInterval(animation_desktop, 1000);
  
  function animation_mobile(){
    $(".razorpay_btn_wrapper .carousel.mobile").toggleClass("transform");
    setTimeout(function(){
      $(".razorpay_btn_wrapper .carousel.mobile").toggleClass("transform-more");
    }, 1000);
    $(".razorpay_btn_wrapper .crumbs.mobile .crumb-item:nth-child(1)").toggleClass("dark");
    $(".razorpay_btn_wrapper .crumbs.mobile .crumb-item:nth-child(2)").toggleClass("light");
   }
    window.setInterval(animation_mobile, 2000);
    function check_sold_out() {
        if ($(".product-main .product-form--atc-button").hasClass("disabled")) {
            $(".product-main #gokwik-buy-now").addClass("hide_it");
        } else {
            $(".product-main #gokwik-buy-now").removeClass("hide_it");
        }
    }
    function check_variant_change(){
      $(".product-main [data-variant-option]").each(function () {
          $(this).on("change", function () {
              setTimeout(function () {
                  check_sold_out();
              }, 100);
          });
      });    
    }
    check_sold_out();
    check_variant_change();

  var targetNode = document.querySelector('.modal-content');
  var config = { childList: true, subtree: true };
  
  var callback = function(mutationsList, observer) {
      for(var mutation of mutationsList) {
          if (mutation.type === 'childList') {
              // Check if added nodes match the selector
              var addedNodes = mutation.addedNodes;
              for (var i = 0; i < addedNodes.length; i++) {
                  if (addedNodes[i].nodeType === 1 && addedNodes[i].classList.contains('product--outer')) {
                    check_sold_out();
                    check_variant_change();
                  }
              }
          }
      }
  };
  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
});
document.addEventListener('DOMContentLoaded', function() {
    function repositionIframe() {
        const iframes = document.querySelectorAll('iframe[title="chat widget"]');

         if (window.innerWidth <= 768) {
        iframes.forEach(iframe => {
            iframe.style.cssText += "z-index: 999 !important; bottom: 63px !important;";
            // Apply the z-index to the iframe's parent element
            const parentDiv = iframe.parentElement;
            if (parentDiv) {
                parentDiv.style.cssText += "z-index: 999 !important;";
            }
        });
    }
    }
    repositionIframe();

    const observer = new MutationObserver(repositionIframe);
    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', repositionIframe);

  function isMobileView() {
    return window.innerWidth <= 768;
  }

  function checkPopupDisplay() {
    if (isMobileView()) {
      let popup = document.querySelector('.show-acc-tab');
      let popupStyle = window.getComputedStyle(popup);
      let siteHeader = document.querySelector('.site-header');

      if (popupStyle.display === 'block') {
        siteHeader.style.zIndex = '1000';
      } /*else if (siteHeader.style.zIndex !== '1000') {
        siteHeader.style.zIndex = '';
      }*/
    }
  }
  setInterval(checkPopupDisplay, 500); 
  
});
          // ---redirection of page not remove ---dropshipping---
  if (window.location.href.includes('/pages/deodap-dropshipping')) {
    window.location.href = 'https://dropshipping.deodap.com';
  }


document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".slider");
    let isDown = false;
    let startX;
    let scrollLeft;
    let moved = false;
    let threshold = 0; // Allow dragging even with the smallest movement

    slider.addEventListener("mousedown", (e) => {
        isDown = true;
        moved = false;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        e.preventDefault();
    });

    slider.addEventListener("mouseleave", () => {
        isDown = false;
    });

    slider.addEventListener("mouseup", () => {
        isDown = false;
    });

    slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 4; // Keep smoothness factor

        if (Math.abs(walk) > threshold) {
            moved = true;
        }

        slider.scrollLeft = scrollLeft - walk;
    });

    // Prevent clicking on links when dragging
    slider.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", (e) => {
            if (moved) {
                e.preventDefault();
            }
        });
    });

    // Prevent dragging images
    document.querySelectorAll(".slideshow__media img").forEach((img) => {
        img.addEventListener("dragstart", (e) => e.preventDefault());
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const menuDrawer = document.querySelector(".menu-drawer-container");

    function toggleBodyScroll() {
        if (window.innerWidth <= 768) { // Apply only for mobile screens
            if (menuDrawer.classList.contains("menu-opening")) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "";
            }
        } else {
            document.body.style.overflow = ""; // Ensure scrolling is enabled on larger screens
        }
    }

    const observer = new MutationObserver(toggleBodyScroll);
    observer.observe(menuDrawer, { attributes: true, attributeFilter: ["class"] });

    window.addEventListener("resize", toggleBodyScroll); // Ensure behavior updates on resize
});
document.addEventListener("DOMContentLoaded", function () {
    const menuDrawer = document.querySelector(".hamburger-coll");

    function toggleBodyScroll() {
        if (window.innerWidth <= 768) { 
            if (menuDrawer.classList.contains("active")) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "";
            }
        } else {
            document.body.style.overflow = ""; 
        }
    }

    const observer = new MutationObserver(toggleBodyScroll);
    observer.observe(menuDrawer, { attributes: true, attributeFilter: ["class"] });

    window.addEventListener("resize", toggleBodyScroll); 
});
document.addEventListener("DOMContentLoaded", function () {
    function addClassOnMenuOpen() {
        const menuDrawer = document.querySelector(".menu-drawer-container");
        const whatmoreReact = document.querySelector(".whatmore-react-draggable");

        if (menuDrawer && whatmoreReact) {
            if (window.innerWidth <= 768) { 
                if (menuDrawer.classList.contains("menu-opening")) {
                    whatmoreReact.classList.add("hamb-whatmore-zind");
                } else {
                    whatmoreReact.classList.remove("hamb-whatmore-zind");
                }
            } else {
               
                whatmoreReact.classList.remove("hamb-whatmore-zind");
            }
        }
    }

    
    const menuDrawer = document.querySelector(".menu-drawer-container");
    if (menuDrawer) {
        const observer = new MutationObserver(addClassOnMenuOpen);
        observer.observe(menuDrawer, { attributes: true, attributeFilter: ["class"] });
    }

   
    window.addEventListener("resize", addClassOnMenuOpen);
});

document.addEventListener("DOMContentLoaded", function() {
  function updateStickyHeight() {
    var newSticky = document.querySelector('.new-sticky');
    if (newSticky) {
      var stickyHeight = newSticky.offsetHeight;
      var viewportHeight = window.innerHeight;
      var stickyHeightPercentage = (stickyHeight / viewportHeight) * 100;
      document.documentElement.style.setProperty('--new-sticky-height', stickyHeightPercentage + '%');
    }
  }

  updateStickyHeight();
  window.addEventListener('resize', updateStickyHeight);
});
document.addEventListener("DOMContentLoaded", function () {
    function addClassOnMenuOpen() {
        const menuDrawer = document.querySelector(".hamburger-coll");
        const whatmoreReact = document.querySelector(".whatmore-react-draggable");

        if (menuDrawer && whatmoreReact) {
            if (window.innerWidth <= 768) { 
                if (menuDrawer.classList.contains("active")) {
                    whatmoreReact.classList.add("hamb-whatmore-zind");
                } else {
                    whatmoreReact.classList.remove("hamb-whatmore-zind");
                }
            } else {
              
                whatmoreReact.classList.remove("hamb-whatmore-zind");
            }
        }
    }

    
    const menuDrawer = document.querySelector(".hamburger-coll");
    if (menuDrawer) {
        const observer = new MutationObserver(addClassOnMenuOpen);
        observer.observe(menuDrawer, { attributes: true, attributeFilter: ["class"] });
    }

    
    window.addEventListener("resize", addClassOnMenuOpen);
});



 